var _Info, _AnimatedStaticCoinRi;
import Info from '@crehana/compass.icons.outline/Info';
import { LazyImage } from '@crehana/compass.ui';
import { AnimatedStaticCoinRive } from "../../../../AnimatedStaticCoinRive";
import { usePlayroomRewardsTranslations } from "../../../hooks";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var ExchangeInsufficient = function ExchangeInsufficient(_ref) {
  var reward = _ref.reward,
    customCurrencyName = _ref.customCurrencyName,
    totalUserCrehanaCoins = _ref.totalUserCrehanaCoins;
  var _usePlayroomRewardsTr = usePlayroomRewardsTranslations(),
    t = _usePlayroomRewardsTr.t;
  var CUSTOM_FORMATTER_REGEX = /\*(.*?)\*/;
  var REMAINING_COINS_IF_REDEEM_THIS_ELEMENT = reward.coins - totalUserCrehanaCoins;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("section", {
      className: "tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-1.6 tw-mb-2.4",
      children: [/*#__PURE__*/_jsx(LazyImage, {
        src: reward.imageSrc || '',
        alt: reward.title,
        className: "tw-overflow-hidden tw-rounded-1.2 tw-w-full tw-h-14.4 sm:tw-h-20 md:tw-h-auto tw-grayscale",
        imgClassName: "tw-object-cover tw-w-full tw-h-full"
      }), /*#__PURE__*/_jsxs("section", {
        children: [/*#__PURE__*/_jsxs("div", {
          className: "tw-flex tw-px-1.2 tw-py-0.8 tw-rounded-0.4 tw-bg-neutral-light-200 dark:tw-bg-elevation-dark-03 tw-mb-1.2",
          children: [_Info || (_Info = /*#__PURE__*/_jsx(Info, {
            size: 20,
            className: "tw-text-warning-400"
          })), /*#__PURE__*/_jsx("p", {
            className: "tw-ml-0.8 tw-flex-1 tw-font-body5",
            children: t('PRS_MISSING_CREHANACOINS', {
              interpolation: {
                coins: REMAINING_COINS_IF_REDEEM_THIS_ELEMENT,
                currencyName: customCurrencyName
              },
              formatter: function formatter(text) {
                return text.replace(CUSTOM_FORMATTER_REGEX, function (_, replaced) {
                  return "<span class=\"tw-font-link1 tw-text-warning-400\">".concat(replaced, "</span>");
                });
              }
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("h3", {
            className: "tw-font-subtitle3 tw-mb-1.2",
            children: reward.title
          }), /*#__PURE__*/_jsx("p", {
            className: "tw-font-body4 tw-mb-0.8 tw-max-h-8 tw-overflow-y-auto sm:tw-max-h-full sm:tw-line-clamp-6",
            children: reward.description
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "tw-flex tw-items-center tw-text-neutral-light-700",
          children: [_AnimatedStaticCoinRi || (_AnimatedStaticCoinRi = /*#__PURE__*/_jsx(AnimatedStaticCoinRive, {
            className: "tw-grayscale"
          })), /*#__PURE__*/_jsx("p", {
            className: "tw-ml-0.4 tw-font-subtitle5",
            children: t('PRS_X_CREHANACOINS', {
              interpolation: {
                coins: reward.coins,
                currencyName: customCurrencyName
              }
            })
          })]
        })]
      })]
    })
  });
};
export default ExchangeInsufficient;